import { ApiContext } from '@sleepstation/components-context'
import { CopyParagraph } from '@sleepstation/components-copy'
import { SmallFormSuccessMessage } from '@sleepstation/components-form'
import { MailingListSignupForm } from '@sleepstation/components-forms-shared'
import { STATUS } from '@sleepstation/const'
import React, { useContext, useState } from 'react'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const SUCCESS_TITLE = `Thank you for subscribing`
const SUCCESS_BODY = `You’ve been added to our mailing list.`

const FAILURE_MESSAGE = `Sorry. Something went wrong.`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const MailingListSignupAction = () => {
  const api = useContext(ApiContext)

  const [status, setStatus] = useState(STATUS.PENDING)

  const { getOnboardingMailingListSignup } = api

  if (status === STATUS.SUCCEEDED) {
    return <SmallFormSuccessMessage title={SUCCESS_TITLE} body={SUCCESS_BODY} />
  }

  if (status === STATUS.FAILED) {
    return <CopyParagraph>{FAILURE_MESSAGE}</CopyParagraph>
  }

  return (
    <MailingListSignupForm
      promise={getOnboardingMailingListSignup}
      onSuccess={() => setStatus(STATUS.SUCCEEDED)}
      onFailure={() => setStatus(STATUS.FAILED)}
    >
      Sign Up
    </MailingListSignupForm>
  )
}

export default MailingListSignupAction
